import { MappingSummary, TreeCreateData } from './types'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from '@mui/material'
import { goToTree } from '../tree/TreeActions'

export function ScopeSequenceTreeCreateResponse({
  data,
}: {
  data: TreeCreateData
}) {
  const { curriculum_id, tree_id: treeId, version_id: versionId } = data
  return (
    <Box>
      <Box>{`Curriculum Id: ${curriculum_id}`}</Box>
      <Box>{`Tree Id: ${treeId}:${versionId}`}</Box>
      <Box>
        <Button onClick={() => goToTree({ treeId, versionId })}>Open</Button>
      </Box>
      {data.mapping_summary && (
        <SkillsMappingSummary summary={data.mapping_summary} />
      )}
    </Box>
  )
}

function SkillsMappingSummary({ summary }: { summary: MappingSummary }) {
  return (
    <Box mt={2}>
      <Typography variant="subtitle2" gutterBottom>
        Skills Mapping
      </Typography>
      <Box display="flex" gap={3} mb={1}>
        <Typography variant="body2">
          <strong>Total:</strong> {summary.total_skills}
        </Typography>
        <Typography variant="body2" color="success.main">
          <strong>Mapped:</strong> {summary.mapped}
        </Typography>
        <Typography variant="body2" color="error.main">
          <strong>Removed:</strong> {summary.removed}
        </Typography>
      </Box>
      {summary.unmapped_codes.length > 0 && (
        <Accordion>
          <AccordionSummary>
            <Typography variant="body2">
              Unmapped Codes ({summary.unmapped_codes.length})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" flexWrap="wrap" gap={1}>
              {summary.unmapped_codes.map((code) => (
                <Typography key={code} variant="body2" component="code">
                  {code}
                </Typography>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      )}
      <Accordion>
        <AccordionSummary>
          <Typography variant="body2">
            Mapped Codes ({Object.keys(summary.mapped_codes).length})
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            {Object.entries(summary.mapped_codes).map(
              ([source, { target_codes }]) => (
                <Box key={source} display="flex" gap={1}>
                  <Typography variant="body2" component="code">
                    {source}
                  </Typography>
                  <Typography variant="body2">{'\u2192'}</Typography>
                  <Typography variant="body2" component="code">
                    {target_codes.join(', ')}
                  </Typography>
                </Box>
              ),
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}
